import { PersonType, ForeignNational } from 'API';
import { useContext } from 'react';
import CompanyContext from 'shared/contexts/CompanyContext';
import ProfileContext from 'shared/contexts/ProfileContext';
import UserContext from 'shared/contexts/UserContext';

/**
 * Returns a function that determines whether the current user
 * can read a field.
 */
const useCanViewField = (): (
field: ToggleableField, type?: ProfileType) => boolean => {
  const [userState] = useContext(UserContext);
  const [profile, , profileType] = useContext(ProfileContext);
  const [company] = useContext(CompanyContext);
  const { adminCompanies, role, person } = userState;

  return (field: ToggleableField, type?: ProfileType): boolean => {
    if (!type || !field.fieldName) {
      return false;
    }

    // const isSelf = profile?.id === person.id;

    const isRelativeAdmin = profileType === PersonType.ForeignNational
      && ((profile as unknown) as ForeignNational)?.relativeAdmins?.includes(
        person.id,
      );

    const isCompanyAdmin = (company?.id && adminCompanies.includes(company.id))
      || (profile
        && profileType === PersonType.ForeignNational
        && ((profile as unknown) as ForeignNational).companyID
        && adminCompanies.includes(
          ((profile as unknown) as ForeignNational).companyID as string,
        ));

    const canView = Boolean(field.canView.includes(role)
      // || (field.selfCanEdit && isSelf)
      || (field.relativeAdminsCanEdit && isRelativeAdmin)
      || (field.companyAdminsCanEdit && isCompanyAdmin));

    return canView;
  };
};

export default useCanViewField;
